import React, { useEffect, useState } from 'react';
import { CalendarMonth, Diversity1, Diversity2, Person } from '@mui/icons-material';
import { Table } from 'react-bootstrap';
import _fetch from '../../config/api';
import { api_url } from '../../config/Config';
import { useTranslation } from 'react-i18next';
import { ColorRing } from "react-loader-spinner";

const MainOverview = (props: any) => {

    const { t, i18n } = useTranslation();

    const [allUserData, setAllUserData] = useState({ totalTeam: 0, boosterIncome: 0, totalIncome: "", avaliableIncome: "", TotalDeposit: "", AvaliableDeposit: { fundValue: "", reBuyValue: "" }, directIncome: "", levelIncome: "", poolIncome: "", roiIncome: "", royaltyIncome: "", profitDetails: { todayProfit: 0, yesterdayProfit: 0, lastMonthProfit: 0, currentMonthProfit: 0, last7DaysProfit: 0 }, userInfo: { user_info: { name: "", income_limit: "", package: { current_package: "", previous_package: "", total_package: "" } } } });
    const [loading, setLoading] = useState(false);
    const [info, setInfo] = useState({ teamBusiness: 0, business: { direct_business: 0, team_business: 0 }, directs: { total: 0 } });
    const [teamBusiness, setTeamBusiness] = useState(0);
    const [yesterdayBusiness, setYesterdayBusiness] = useState(0);
    const [last7Days, setLast7Days] = useState(0);
    const [currentMonth, setCurrentMonth] = useState(0);
    const [lastMonth, setLastMonth] = useState(0);

    useEffect(() => {
        document.title = `${props.pageTitle}`;
        // getUserData();
        getUserInfo();
    }, []);

    // const getUserData = async () => {
    //     let res = await _fetch(`${api_url}profile/dashboard`, "GET", {})
    //     if (res?.status === "success") {
    //         setAllUserData(res?.data);
    //     }
    // }

    const getUserInfo = async () => {
        setLoading(true);

        let resUserDetail = await _fetch(`${api_url}profile/dashboard`, "GET", {})
        let userInfoRes = await _fetch(`${api_url}user/userInfo`, "GET", {});
        let res = await _fetch(`${api_url}report/team-business`, "GET", {});

        if (resUserDetail?.status === "success") {
            setAllUserData(resUserDetail?.data);
        }

        if (userInfoRes?.status === 'success') {
            setInfo(userInfoRes?.data?.data);
        }

        if (res?.status === 'success') {
            setLoading(false);
            setTeamBusiness(res?.data?.teamBusiness);
            setYesterdayBusiness(res?.data?.yesterdayBusiness);
            setLast7Days(res?.data?.last7DaysBusiness);
            setCurrentMonth(res?.data?.currentMonthBusiness);
            setLastMonth(res?.data?.lastMonthBusiness);
        }
    }

    return (
        <>
            <main>
                <div className='main-overview'>
                    <div className='main-card-overview card'>
                        <div className='card-header'>
                            <h4>{t("Overview")}</h4>
                        </div>
                        <div className='card-body'>
                            <div className='row'>
                                <div className='col-md-4'>
                                    <ul className='left-view-1'>
                                        <li>
                                            <div className='view-1-left'>
                                                <span> <Diversity2 /></span>
                                            </div>
                                            <div className='view-1-right'>
                                                <p>{t("Team")}</p>
                                                <p>{allUserData?.totalTeam}</p>
                                            </div>
                                        </li>
                                        <li>
                                            <div className='view-1-left'>
                                                <span> <Diversity1 /></span>
                                            </div>
                                            <div className='view-1-right'>
                                                <p>{t("Frontlines")}</p>
                                                <p>{info?.directs?.total}</p>
                                            </div>
                                        </li>
                                    </ul>
                                </div>

                                <div className='col-md-8'>
                                    <div className='right-view-vb loader_main'>
                                        {loading &&
                                            <div className="spinner_bg">
                                                <div className="color_ring">  <ColorRing
                                                    visible={true}
                                                    height="80"
                                                    width="80"
                                                    ariaLabel="blocks-loading"
                                                    wrapperStyle={{}}
                                                    wrapperClass="blocks-wrapper"
                                                    colors={['#2b3892', '#2b3892', '#2b3892', '#2b3892', '#2b3892']}
                                                />
                                                </div>
                                            </div>
                                        }

                                        <div className='left-vb-sec'>
                                            <div className='vb-sec-outer active'>
                                                <p>{t("Total Business")}</p>
                                                <p>${teamBusiness}</p>
                                            </div>

                                            <div className='vb-sec-outer'>
                                                <p>{t("Yesterday")}</p>
                                                <p>${yesterdayBusiness}</p>
                                            </div>

                                            <div className='vb-sec-outer'>
                                                <p>{t("Last 7 Days")}</p>
                                                <p>${last7Days}</p>
                                            </div>

                                            <div className='vb-sec-outer'>
                                                <p>{t("Current Month")} </p>
                                                <p>${currentMonth}</p>
                                            </div>

                                            <div className='vb-sec-outer'>
                                                <p>{t("Last Month")} </p>
                                                <p>${lastMonth}</p>
                                            </div>
                                        </div>

                                        <div className='left-vb-sec d-none'>
                                            <div className='vb-sec-outer active'>
                                                <p>Total Business</p>
                                                <p>${info?.business?.team_business}</p>
                                            </div>

                                            <div className='vb-sec-outer'>
                                                <p>Yesterday</p>
                                                <p>${allUserData?.profitDetails?.yesterdayProfit}</p>
                                            </div>

                                            <div className='vb-sec-outer'>
                                                <p>Last 7 Days</p>
                                                <p>${allUserData?.profitDetails?.last7DaysProfit}</p>
                                            </div>

                                            <div className='vb-sec-outer'>
                                                <p>Current Month </p>
                                                <p>${allUserData?.profitDetails?.currentMonthProfit}</p>
                                            </div>

                                            <div className='vb-sec-outer'>
                                                <p>Last Month </p>
                                                <p>${allUserData?.profitDetails?.lastMonthProfit}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </>
    );
}

export default MainOverview;
